<template>
  <div class="titleNav">
    <div class="navLeft">
      <img src="../../../assets/imgs/LOGO.png" width="160px" height="49px" alt="" />
      <div class="titleName">
        <span class="titleTopName">客如意 | 云POS系统</span>
        <span class="titleBottomName">{{name}} | {{posDescription}}</span>
      </div>
    </div>
    <div class="navRight">
      <div class="navBox">

        <sideBar />
      </div>
      <div class="personal" @click="posCode">
        <!-- <img src="../../../assets/imgs/LOGO.png" width="60px" height="60px" alt="" /> -->

        <el-image :src="imgBaseurl + logo" lazy fit="cover" style="height:60px;width:60px;margin-right: 10px">
          <div slot="error" class="image-slot">
            <img src="../../../assets/imgs/logo1.png" width="60px" height="60px" alt="" />
          </div>
        </el-image>

        <div class="personName">
          <span>{{username}}</span>
          <span> {{businessDate}} | {{shift == 1 ? '早班' : shift == 2 ? '中班' : shift == 3 ? '晚班' : '夜班'  }} </span>
        </div>
        <div class="signOut" @click.stop="logout">退出</div>
      </div>
    </div>
  </div>
</template>

<script>
  import DateUtils from '@/utils/DateUtils';

  import sideBar from '../components/Sidebar/index.vue'
  export default {
    components: {
      sideBar
    },
    data() {
      return {
        imgBaseurl: '',
        currentData: 0,
        nav: [{
            img: require("../../../assets/imgs/LOGO.png"),
            name: "台位"
          },
          {
            img: require("../../../assets/imgs/LOGO.png"),
            name: "接班"
          },
          {
            img: require("../../../assets/imgs/LOGO.png"),
            name: "菜品维护"
          },
          {
            img: require("../../../assets/imgs/LOGO.png"),
            name: "餐单查询"
          },
          // { img: require("../../../assets/imgs/LOGO.png"), name: "营业状况" },
          // { img: require("../../../assets/imgs/LOGO.png"), name: "预订" },
          {
            img: require("../../../assets/imgs/LOGO.png"),
            name: "厨打"
          },
          // { img: require("../../../assets/imgs/LOGO.png"), name: "报表" },
          {
            img: require("../../../assets/imgs/LOGO.png"),
            name: "锁屏"
          },
        ],

        hotel: JSON.parse(localStorage.getItem('hotel')),
        businessDate: localStorage.getItem('businessDate'),
        posDescription: localStorage.getItem('posDescription'),
        shift: localStorage.getItem('shift'),
        user: JSON.parse(localStorage.getItem('user')),
        name: '',
        logo: '',
        username: '',
        area: '',
      };
    },
    created() {

      this.name = this.hotel.name
      if (this.user.headPortrait) {
        this.logo = this.user.headPortrait

      }
      if (this.user.name) {
        this.username = this.user.username

      }
      if (this.hotel.area) {
        this.area = this.hotel.area

      }

      this.getdata()

    },
    methods: {
      posCode() {
        this.$confirm(`当前登录的站点为：${localStorage.getItem('posCode')}`, '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false,
          center: true
        }).then(() => {

        })
      },
      logout() {
        let url = this.api.logout
        let methods = 'post'
        this.$axios({
          url,
          methods
        }).then(res => {
          if (res.data.status == 0) {

            this.$store.commit('routePathDashboard')
            localStorage.removeItem('hotel')
            localStorage.removeItem('businessDate')
            localStorage.removeItem('user')
            localStorage.removeItem('token')
            localStorage.removeItem('openTaiUser')
            localStorage.removeItem('openTaiUstatus')

            this.$router.push({
              path: 'login'
            })
            this.$bus.$emit('logout', 1)

          }

        });

      },
      getdata() {

      

        let currentTime = DateUtils.formatDate(new Date(), 'yyyy-MM-dd')
        // let businessDate = businessDate
        var date = new Date(this.businessDate);
        var time1 = date.getTime();
        var date1 = new Date(currentTime);
        var time2 = date1.getTime();
        console.log(time2, time1);
        if (time2 > time1) {
          this.$alert('注意！当前系统营业日期早于自然日期，请检查是否未过夜审！', '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          })
        } else {

        }
      }
    },
  };
</script>



<style rel="stylesheet/scss" lang="scss" scoped>
  .titleNav {
    padding: 0 20px 0 30px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;

    .navLeft {
      display: flex;

      .titleName {
        display: flex;
        flex-direction: column;
        margin-left: 16px;

        .titleTopName {
          font-size: 20px;
          color: #0099ff;
          font-weight: 500;
        }

        .titleBottomName {
          margin-top: 8px;
          font-size: 16px;
          color: #666666;
        }
      }
    }

    .navRight {
      height: 100%;
      display: flex;
      align-items: center;

      .navBox {
        display: flex;
        height: 100%;
        cursor: pointer;

        .nav {
          display: flex;
          width: 100px;
          height: 100%;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          span {
            margin-top: 17px;
            color: #bdbdbd;
            font-size: 20px;
          }
        }

        .nav:hover {
          background: #0099ff;

          span {
            color: #fff;
          }
        }

        .current {
          background: #0099ff;

          span {
            color: #fff;
          }
        }
      }

      .personal {
        height: 100%;
        align-items: center;
        display: flex;
        margin-left: 10px;

        img {
          margin-right: 10px;
          border-radius: 30px;
        }

        .personName {
          display: flex;
          flex-direction: column;
          margin-right: 20px;

          span:nth-child(1) {
            margin-bottom: 5px;
            font-size: 20px;
            font-weight: 500;
            color: #666666;
          }

          span:nth-child(2) {
            font-size: 14px;
            font-weight: 400;
            color: #666666;
          }
        }

        .signOut {
          width: 80px;
          height: 40px;
          color: #fff;
          background: #0099ff;
          text-align: center;
          justify-content: center;
          border-radius: 30px;
          line-height: 40px;
          cursor: pointer;
        }
      }
    }
  }
</style>